export const deCase01Messages = {
  "intro-page.case01.title": `Über ATMOS Truck`,
  "intro-page.case01.navbarTitle": `Atmos Truck Live Streaming`,
};
